import { SelectButtonDesignTokens } from '@primeuix/themes/types/selectbutton';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/selectbutton/index.ts
const sb = componentCommon.selectbutton;
const sbCs = componentColorScheme.selectbutton;

export const SelectbuttonTelekomDT: SelectButtonDesignTokens = {
  root: {
    borderRadius: t(sb.border.radius),
  },
  colorScheme: {
    light: {
      root: {
        invalidBorderColor: t(sbCs.invalid.border.color),
      },
    },
  },
};
